module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.job_no ||
        _vm.Filter.isEmailSendStatus ||
        _vm.Filter.email_type ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.job_no ||
    _vm.Filter.isEmailSendStatus ||
    _vm.Filter.email_type ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getEmailLogList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getEmailLogList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "50",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.resetPaginationAndLoad()
      }
    },
    model: {
      value: (_vm.Filter.isEmailSendStatus),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "isEmailSendStatus", $$v)
      },
      expression: "Filter.isEmailSendStatus"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.resetPaginationAndLoad()
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Job No Filter",
      "id": "job_no",
      "name": "job_no",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.resetPaginationAndLoad()
      }
    },
    model: {
      value: (_vm.Filter.job_no),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "job_no", $$v)
      },
      expression: "Filter.job_no"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.resetPaginationAndLoad()
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getEmailLogList,
      "fields": _vm.emailLogFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "ClientName",
      fn: function(row3) {
        return [(row3.item.ClientName) ? _c('span', [_vm._v("Client : " + _vm._s(row3.item.ClientName)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.SlineName) ? _c('span', [_vm._v("Sline : " + _vm._s(row3.item.SlineName)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "fullDocumentLink",
      fn: function(row1) {
        return [_c('b-badge', {
          attrs: {
            "variant": row1.item.is_exp_mail_send == 0 ? 'danger' : 'success'
          }
        }, [_vm._v(_vm._s(row1.item.isEmailSendStatus))]), _vm._v(" "), (row1.item.fullDocumentLink) ? _c('div', _vm._l((row1.item.fullDocumentLink.split(',')), function(item1, index) {
          return _c('b-button', {
            key: index,
            staticClass: "mb-1",
            staticStyle: {
              "margin-left": "2px",
              "font-size": "0.675rem"
            },
            attrs: {
              "size": "sm",
              "variant": "warning"
            },
            on: {
              "click": function($event) {
                item1 ? _vm.PrintValidity_Doc(item1, row1.item.JobNo) : ''
              }
            }
          }, [_vm._v(_vm._s(item1 ? "PDF" + (parseInt(index) + 1) : ""))])
        })) : _vm._e()]
      }
    }, {
      key: "ExpCreatedByEmail",
      fn: function(row5) {
        return [(row5.item.ExpCreatedByEmail) ? _c('div', {
          staticClass: "text-left"
        }, [(row5.item.ExpCreatedByEmail) ? _c('div', _vm._l((row5.item.ExpCreatedByEmail.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "ExpCreatedBy",
      fn: function(row3) {
        return [(row3.item.ExpCreatedBy) ? _c('span', [_vm._v("Raised By : " + _vm._s(row3.item.ExpCreatedBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.ExpCreatedDate) ? _c('span', [_vm._v("Created Date : " + _vm._s(row3.item.ExpCreatedDate)), _c('br')]) : _vm._e(), _vm._v(" "), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.ViewEmail(row3.item)
            }
          }
        }, [_vm._v("View EMail")]), _vm._v(" "), (row3.item.is_exp_mail_send == 0) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.sendEmail(row3.item)
            }
          }
        }, [_vm._v("Send")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "50",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-email-log",
    attrs: {
      "id": "modal-email-log",
      "title": _vm.Email_JobNo,
      "size": "lg",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [(_vm.Email_log_body.isEmailSendStatus) ? _c('h3', [_vm._v(_vm._s(_vm.Email_log_body.isEmailSendStatus))]) : _vm._e(), _vm._v(" "), [_c('div', {
    staticClass: "email-container"
  }, [_c('p', [_vm._v("Hi Team Accounts,")]), _vm._v(" "), _c('p', [_vm._v("\n          Expenses Payment Request has been issued for assignment No. :\n          "), _c('strong', [_vm._v(_vm._s(_vm.Email_log_body.JobNo))])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "width": "100%"
    },
    attrs: {
      "border": "1",
      "cellpadding": "5",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('th', [_vm._v("Assignment No")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.JobNo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Assignment Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.JobCreatedDate))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Raised From")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.RaisedFrom))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Raised By")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.RaisedBy))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.ClientName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Shipping Line")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.SlineName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Handover")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.HAND))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Stuffing")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.STUFF))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Pickup")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.PICK))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.containerType))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("POR")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.POR))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("POL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.POL))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("POD")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.POD))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("FPOD")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.FPOD))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Remark")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.docRemarks))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Request Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.ExpCreatedDate))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Request Issued By")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email_log_body.ExpCreatedBy))])])]), _vm._v(" "), _c('p', [_vm._v("Thanks,")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("TEAM PRANALI")])])])], _vm._v(" "), (_vm.Email_fullDocumentLink.length > 0) ? _c('b', [_c('u', [_c('h4', [_vm._v("Supporting Documents")])]), _c('br'), _vm._v(" "), _vm._l((_vm.Email_fullDocumentLink.split(',')), function(item_doc, index_doc) {
    return _c('span', {
      key: index_doc
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.PrintValidity_Doc(item_doc, _vm.Email_JobNo)
        }
      }
    }, [_vm._v("View Doc - " + _vm._s(index_doc + 1))]), _c('br')])
  })], 2) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeEmailLog
    }
  }, [_vm._v("\n      Close")])], 2), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e60ec650","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/expense/FailedExpenseList.vue
// module id = 2895
// module chunks = 0